<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        let params = {
          limit: 100000
        }

        this.list = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map(obj => {
              this.list.push({
                text: obj.name,
                value: obj.id
              })
            })
          }
        })
      },
      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/salary',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Kode',
              width: '200px',
              value: 'code',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'name',
              sortable: false,
              freeze: false,
              hide: false
            },
            {
              text: 'Gaji Pokok',
              width: '200px',
              value: 'basic_value',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'number'
            },
            {
              text: 'Tunjangan Tetap',
              width: '200px',
              value: 'fixed_value',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'number'
            },
            {
              text: 'Tunjangan Tidak Tetap',
              width: '200px',
              value: 'non_fixed_value',
              sortable: false,
              freeze: false,
              hide: false,
              format: 'number'
            },
            {
              text: 'Posisi',
              width: '200px',
              value: 'position',
              sortable: false,
              freeze: false,
              hide: false
            },
          ],

          // CONFIG PARSING FILTER
          filter: [
            {
              field: 'unit_id',
              label: 'Unit',
              type: 'select',
              placeholder: 'Contoh. Kantor Pusat SDM',
              value: '',
              option: this.list,
              width: '70%',
              required: false
            }
          ],

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'basic_value',
              label: 'Gaji Pokok',
              type: 'text',
              placeholder: 'Contoh. 3.000.000',
              value: '',
              width: '60%',
              required: true,
              rules: 'required'
            },
            {
              field: 'fixed_value',
              label: 'Tunjangan Tetap',
              type: 'text',
              placeholder: 'Contoh. 1.000.000',
              value: '',
              width: '60%',
              required: true,
              rules: 'required'
            },
            {
              field: 'non_fixed_value',
              label: 'Tunjangan Tidak Tetap',
              type: 'text',
              placeholder: 'Contoh. 600.000',
              value: '',
              width: '60%',
              required: true,
              rules: 'required'
            },
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: true,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'admin/salary/update',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: true,
              api: '/salary/history/',
              text: 'Riwayat Gaji'
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>